export class PayerTypeModel {

    // int
    PayerTypeId: number;

    // [Required]
    // [StringLength(100)]
    PayerTypeName: string;
}
